<template>
  <el-dialog :close-on-click-modal="false" class="add-question-bank" :visible.sync="dialogVisible">
    <div class="title">配置题库</div>
    <div class="close-icon" @click="dialogVisible = false">
      <i class="el-icon-close"></i>
    </div>
    <div class="content">
      <table-list
        ref="questionBankTable"
        :loading="loading"
        :data="questionBankList"
        :search-form="searchForm(this)"
        :columns="columns(this)"
        :operates="operates(this)"
        :options="{ selection: true, height: 400, selectable: selectEvent, operatesWidth: 170 }"
        @search="onSearch"
        @selectionChange="handleSelectionChange"
      ></table-list>
      <div class="btns">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
const searchForm = () => [
  {
    label: '题库名称',
    prop: 'questionStoreName',
  },
]
// 表格列配置
const columns = () => [
  {
    prop: 'questionStoreName',
    label: '题库名称',
  },
  {
    prop: 'questionTypeMuster',
    label: '试题包含类型',
  },
  {
    prop: 'questionNum',
    label: '题目数量',
    sortable: 'sortable',
  },
]

const operates = _this => [
  {
    label: '查看试题',
    method: _this.handleDelete,
  },
]
import TableList from '@/components/TableList'
import { certQuestionsList, certQuestionsSave } from '@/api/certCenter'
import to from 'await-to'
export default {
  name: 'AddQuestionBank',
  components: { TableList },
  props: {
    classCertId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      searchForm,
      columns,
      operates,
      dialogVisible: false,
      loading: false,
      questionBankList: [],
      select: [],
      queryParams: {},
    }
  },
  methods: {
    show(select = []) {
      this.dialogVisible = true
      this.getList()
      this.$nextTick(() => {
        this.$refs.questionBankTable.$refs.tableList.clearSelection()
        if (select.length) {
          select.forEach(row => {
            this.$refs.questionBankTable.$refs.tableList.toggleRowSelection(row)
          })
        }
      })
    },
    async getList() {
      if (this.loading) return
      this.loading = true
      const [res, err] = await to(
        certQuestionsList({ ...this.queryParams, certPrivateTrainId: this.classCertId }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.questionBankList = res.data.list
    },
    async submit() {
      const courses = this.select.map(item => ({
        certPrivateTrainId: parseInt(this.classCertId),
        relationId: item.questionStoreId,
      }))
      const [, err] = await to(
        certQuestionsSave({
          certPrivateTrainRelationPaperReqDtos: courses,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
      this.$emit('success')
      this.dialogVisible = false
    },
    // 查询按钮
    onSearch(queryParams) {
      this.queryParams = queryParams
      this.getList()
    },
    // 多选
    handleSelectionChange(val) {
      this.select = val
    },
    selectEvent(row) {
      return !row.isPresent
    },
  },
}
</script>
<style lang="scss" scoped>
.add-question-bank {
  ::v-deep.el-dialog {
    position: relative;
    width: 1000px;
    background: #ffffff;
    border-radius: 0;
    color: #4d4e5d;
    .close-icon {
      z-index: 99;
      cursor: pointer;
      position: absolute;
      right: 24px;
      top: 14px;
      font-size: 25px;
      font-weight: bold;
      color: #8c8c8c;
    }
    .el-dialog__header {
      display: none;
    }
    .el-tabs__header {
      margin-bottom: 26px;
      padding-top: 23px;
    }
    .el-dialog__body {
      padding: 0;
    }
    .title {
      height: 62px;
      line-height: 62px;
      border-bottom: 1px solid #c9c9c9;
      padding-left: 30px;
      font-size: 18px;
    }
    .content {
      padding: 30px 10px;
      > .btns {
        text-align: right;
        padding-top: 30px;
      }
    }
    .el-form-item {
      .el-input,
      .el-select,
      .el-date,
      .el-date-editor {
        width: 200px !important;
      }
    }
  }
}
</style>
